import NoticeInPage from "@Components/NoticeInPage";
import React from "react";
import {injectIntl} from "react-intl";

function NoticeInPageCutover({intl, settings}) {
  const isCutOverDisabled = settings?.status;
  if (!isCutOverDisabled) {
      return null;
  }
  const noticeSettings = {
      type: 'warning',
      message: settings?.cutover_notice ?? ''
  };
  return (
    <div className="block block--xs">
      <div className="wrapper block__wrapper">
        <NoticeInPage settings={noticeSettings} style={{maxWidth: '100%'}}/>
      </div>
    </div>
  )
}

export default injectIntl(NoticeInPageCutover);
